module.exports = __webpack_public_path__ + "media/img/sda/Scholarships2U-Virtual-Scholarship-Fair-2020-sda01-06969cf2d1da29869072b35cfbb97aa0.jpg";